import {EcoTransferMethod} from '@app-types/websocket/economy.types';

export interface IPendingEcoTransfer {
  sum: number;
  method: EcoTransferMethod;
}

const STORAGE_KEY_PREFIX = 'pendingEcoTransfer:';

const storageKey = (userId: number) => `${STORAGE_KEY_PREFIX}${userId}`;

const isTransferMethod = (value: unknown): value is EcoTransferMethod =>
  Object.keys(EcoTransferMethod).some((key) => (EcoTransferMethod as any)[key] === value);

export const loadPendingEcoTransfer = (userId: number): IPendingEcoTransfer|undefined => {
  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    if (!raw) {
      return undefined;
    }

    const pending = JSON.parse(raw);
    if (typeof pending.sum !== 'number' || !Number.isFinite(pending.sum) || pending.sum <= 0
      || !isTransferMethod(pending.method)) {
      window.localStorage.removeItem(storageKey(userId));
      return undefined;
    }

    return {sum: pending.sum, method: pending.method};
  } catch (_) {
    return undefined;
  }
};

export const savePendingEcoTransfer = (userId: number, pending: IPendingEcoTransfer): void => {
  try {
    window.localStorage.setItem(storageKey(userId), JSON.stringify(pending));
  } catch (_) {
    // The dialog still works for this session when storage is unavailable.
  }
};

export const clearPendingEcoTransfer = (userId: number): void => {
  try {
    window.localStorage.removeItem(storageKey(userId));
  } catch (_) {
    // Nothing else to clear when storage is unavailable.
  }
};



// WEBPACK FOOTER //
// ./src/helpers/PendingEcoTransfer.ts